import ReduxProvider from './ReduxProvider';

export default ReduxProvider;
